import { getSafDraft, saveDraftSaf, getConsignee, getShipper, postConsignee, editConsignee, deleteConsignee, submitSaf, getBank, downloadDocumentSaf, uploadDocumentSaf, downloadDocumentSafApproved } from '@/api/settings.api'

export const FETCH_SAF_SAVE_DRAFT = 'FETCH_SAF_SAVE_DRAFT'
export const FETCH_SAF_SAVE_DRAFT_LOADING = 'FETCH_SAF_SAVE_DRAFT_LOADING'
export const FETCH_SAF_SAVE_DRAFT_DONE = 'FETCH_SAF_SAVE_DRAFT_DONE'
export const FETCH_SAF_SAVE_DRAFT_ERROR = 'FETCH_SAF_SAVE_DRAFT_ERROR'

export const POST_SAF_SAVE_DRAFT = 'POST_SAF_SAVE_DRAFT'
export const POST_SAF_SAVE_DRAFT_LOADING = 'POST_SAF_SAVE_DRAFT_LOADING'
export const POST_SAF_SAVE_DRAFT_DONE = 'POST_SAF_SAVE_DRAFT_DONE'
export const POST_SAF_SAVE_DRAFT_ERROR = 'POST_SAF_SAVE_DRAFT_ERROR'

export const FETCH_SAF_CONSIGNEE = 'FETCH_SAF_CONSIGNEE'
export const FETCH_SAF_CONSIGNEE_LOADING = 'FETCH_SAF_CONSIGNEE_LOADING'
export const FETCH_SAF_CONSIGNEE_DONE = 'FETCH_SAF_CONSIGNEE_DONE'
export const FETCH_SAF_CONSIGNEE_ERROR = 'FETCH_SAF_CONSIGNEE_ERROR'

export const FETCH_SAF_SHIPPER = 'FETCH_SAF_SHIPPER'
export const FETCH_SAF_SHIPPER_LOADING = 'FETCH_SAF_SHIPPER_LOADING'
export const FETCH_SAF_SHIPPER_DONE = 'FETCH_SAF_SHIPPER_DONE'
export const FETCH_SAF_SHIPPER_ERROR = 'FETCH_SAF_SHIPPER_ERROR'

export const POST_SAF_CONSIGNEE = 'POST_SAF_CONSIGNEE'
export const POST_SAF_CONSIGNEE_LOADING = 'POST_SAF_CONSIGNEE_LOADING'
export const POST_SAF_CONSIGNEE_DONE = 'POST_SAF_CONSIGNEE_DONE'
export const POST_SAF_CONSIGNEE_ERROR = 'POST_SAF_CONSIGNEE_ERROR'

export const EDIT_SAF_CONSIGNEE = 'EDIT_SAF_CONSIGNEE'
export const EDIT_SAF_CONSIGNEE_LOADING = 'EDIT_SAF_CONSIGNEE_LOADING'
export const EDIT_SAF_CONSIGNEE_DONE = 'EDIT_SAF_CONSIGNEE_DONE'
export const EDIT_SAF_CONSIGNEE_ERROR = 'EDIT_SAF_CONSIGNEE_ERROR'

export const DELETE_SAF_CONSIGNEE = 'DELETE_SAF_CONSIGNEE'
export const DELETE_SAF_CONSIGNEE_LOADING = 'DELETE_SAF_CONSIGNEE_LOADING'
export const DELETE_SAF_CONSIGNEE_DONE = 'DELETE_SAF_CONSIGNEE_DONE'
export const DELETE_SAF_CONSIGNEE_ERROR = 'DELETE_SAF_CONSIGNEE_ERROR'

export const POST_SAF_SUBMIT = 'POST_SAF_SUBMIT'
export const POST_SAF_SUBMIT_LOADING = 'POST_SAF_SUBMIT_LOADING'
export const POST_SAF_SUBMIT_DONE = 'POST_SAF_SUBMIT_DONE'
export const POST_SAF_SUBMIT_ERROR = 'POST_SAF_SUBMIT_ERROR'

export const FETCH_SAF_BANK = 'FETCH_SAF_BANK'
export const FETCH_SAF_BANK_LOADING = 'FETCH_SAF_BANK_LOADING'
export const FETCH_SAF_BANK_DONE = 'FETCH_SAF_BANK_DONE'
export const FETCH_SAF_BANK_ERROR = 'FETCH_SAF_BANK_ERROR'

export const DOWNLOAD_SAF_DOCUMENT = 'DOWNLOAD_SAF_DOCUMENT'
export const DOWNLOAD_SAF_DOCUMENT_LOADING = 'DOWNLOAD_SAF_DOCUMENT_LOADING'
export const DOWNLOAD_SAF_DOCUMENT_DONE = 'DOWNLOAD_SAF_DOCUMENT_DONE'
export const DOWNLOAD_SAF_DOCUMENT_ERROR = 'DOWNLOAD_SAF_DOCUMENT_ERROR'

export const UPLOAD_SAF_DOCUMENT = 'UPLOAD_SAF_DOCUMENT'
export const UPLOAD_SAF_DOCUMENT_LOADING = 'UPLOAD_SAF_DOCUMENT_LOADING'
export const UPLOAD_SAF_DOCUMENT_DONE = 'UPLOAD_SAF_DOCUMENT_DONE'
export const UPLOAD_SAF_DOCUMENT_ERROR = 'UPLOAD_SAF_DOCUMENT_ERROR'

export const DOWNLOAD_SAF_DOCUMENT_APPROVED = 'DOWNLOAD_SAF_DOCUMENT_APPROVED'
export const DOWNLOAD_SAF_DOCUMENT_APPROVED_LOADING = 'DOWNLOAD_SAF_DOCUMENT_APPROVED_LOADING'
export const DOWNLOAD_SAF_DOCUMENT_APPROVED_DONE = 'DOWNLOAD_SAF_DOCUMENT_APPROVED_DONE'
export const DOWNLOAD_SAF_DOCUMENT_APPROVED_ERROR = 'DOWNLOAD_SAF_DOCUMENT_APPROVED_ERROR'

export default {
  [FETCH_SAF_SAVE_DRAFT] (context) {
    context.commit(FETCH_SAF_SAVE_DRAFT_LOADING)
    return getSafDraft()
      .then((response) => {
        context.commit(FETCH_SAF_SAVE_DRAFT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SAF_SAVE_DRAFT_ERROR, error)
        console.error(error)
      })
  },

  [POST_SAF_SAVE_DRAFT] (context, payload) {
    context.commit(POST_SAF_SAVE_DRAFT_LOADING)
    return saveDraftSaf(payload)
      .then((response) => {
        context.commit(POST_SAF_SAVE_DRAFT_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_SAF_SAVE_DRAFT_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_SAF_CONSIGNEE] (context) {
    context.commit(FETCH_SAF_CONSIGNEE_LOADING)
    return getConsignee()
      .then((response) => {
        context.commit(FETCH_SAF_CONSIGNEE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SAF_CONSIGNEE_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_SAF_SHIPPER] (context) {
    context.commit(FETCH_SAF_SHIPPER_LOADING)
    return getShipper()
      .then((response) => {
        context.commit(FETCH_SAF_SHIPPER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SAF_SHIPPER_ERROR, error)
        console.error(error)
      })
  },

  [POST_SAF_CONSIGNEE] (context, payload) {
    context.commit(POST_SAF_CONSIGNEE_LOADING)
    return postConsignee(payload)
      .then((response) => {
        context.commit(POST_SAF_CONSIGNEE_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_SAF_CONSIGNEE_ERROR, error)
        console.error(error)
      })
  },

  [EDIT_SAF_CONSIGNEE] (context, payload) {
    context.commit(EDIT_SAF_CONSIGNEE_LOADING)
    return editConsignee(payload)
      .then((response) => {
        context.commit(EDIT_SAF_CONSIGNEE_DONE, response)
      })
      .catch((error) => {
        context.commit(EDIT_SAF_CONSIGNEE_ERROR, error)
        console.error(error)
      })
  },

  [DELETE_SAF_CONSIGNEE] (context, id) {
    context.commit(DELETE_SAF_CONSIGNEE_LOADING)
    return deleteConsignee(id)
      .then((response) => {
        context.commit(DELETE_SAF_CONSIGNEE_DONE, response)
      })
      .catch((error) => {
        context.commit(DELETE_SAF_CONSIGNEE_ERROR, error)
        console.error(error)
      })
  },

  [POST_SAF_SUBMIT] (context, payload) {
    context.commit(POST_SAF_SUBMIT_LOADING)
    return submitSaf(payload)
      .then((response) => {
        context.commit(POST_SAF_SUBMIT_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_SAF_SUBMIT_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_SAF_BANK] (context) {
    context.commit(FETCH_SAF_BANK_LOADING)
    return getBank()
      .then((response) => {
        context.commit(FETCH_SAF_BANK_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SAF_BANK_ERROR, error)
        console.error(error)
      })
  },

  [DOWNLOAD_SAF_DOCUMENT] (context) {
    context.commit(DOWNLOAD_SAF_DOCUMENT_LOADING)
    return downloadDocumentSaf()
      .then((response) => {
        context.commit(DOWNLOAD_SAF_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_SAF_DOCUMENT_ERROR, true)
        console.error(error)
      })
  },

  [UPLOAD_SAF_DOCUMENT] (context, payload) {
    context.commit(UPLOAD_SAF_DOCUMENT_LOADING)
    return uploadDocumentSaf(payload)
      .then((response) => {
        context.commit(UPLOAD_SAF_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(UPLOAD_SAF_DOCUMENT_ERROR, true)
        console.error(error)
      })
  },

  [DOWNLOAD_SAF_DOCUMENT_APPROVED] (context) {
    context.commit(DOWNLOAD_SAF_DOCUMENT_APPROVED_LOADING)
    return downloadDocumentSafApproved()
      .then((response) => {
        context.commit(DOWNLOAD_SAF_DOCUMENT_APPROVED_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_SAF_DOCUMENT_APPROVED_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/saf/actions.js